import React from 'react'

import {Dropdown as AntdDropdown, DropDownProps} from 'antd'

import './dropdown.scss'

export const Dropdown: React.FC<DropDownProps> = props => {
  return <AntdDropdown {...props} />
}
